import { lazy, Suspense } from "react"
import { createBrowserRouter, RouterProvider } from "react-router-dom"

import { AppLayout } from "@/layouts/app-layout"
import { routes } from "@/lib/routes"
import { PageLoader } from "@/components/common/page-loader"

const HomePage = lazy(() => import("@/pages/HomePage"))
const UndergraduatePage = lazy(() => import("@/pages/UndergraduatePage"))
const PostgraduatePage = lazy(() => import("@/pages/PostgraduatePage"))
const UgStatusPage = lazy(() => import("@/pages/UgStatusPage"))
const PgStatusPage = lazy(() => import("@/pages/PgStatusPage"))
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"))

function withSuspense(element: React.ReactNode) {
  return <Suspense fallback={<PageLoader />}>{element}</Suspense>
}

/**
 * Route-level code splitting (migration plan §8) — each page is its own
 * chunk, so the home page's bundle never pays for React Hook Form, Zod, or
 * the eligibility-form widgets it doesn't use.
 */
const router = createBrowserRouter(
  [
    {
      path: routes.home,
      element: <AppLayout />,
      children: [
        {
          index: true,
          element: withSuspense(<HomePage />),
          handle: { crumb: "Reliance Foundation Scholarships" },
        },
        {
          path: "UG_Scholarship",
          element: withSuspense(<UndergraduatePage />),
          handle: { crumb: "Undergraduate Scholarship" },
        },
        {
          path: "UG_Scholarship.aspx",
          element: withSuspense(<UndergraduatePage />),
          handle: { crumb: "Undergraduate Scholarship" },
        },
        {
          path: "UG_Scholarship/status",
          element: withSuspense(<UgStatusPage />),
          handle: { crumb: "Undergraduate Application Status" },
        },
        {
          path: "PG_Scholarship",
          element: withSuspense(<PostgraduatePage />),
          handle: { crumb: "Postgraduate Scholarship" },
        },
        {
          path: "PG_Scholarship.aspx",
          element: withSuspense(<PostgraduatePage />),
          handle: { crumb: "Postgraduate Scholarship" },
        },
        {
          path: "PG_Scholarship/status",
          element: withSuspense(<PgStatusPage />),
          handle: { crumb: "Postgraduate Application Status" },
        },
        {
          path: "*",
          element: withSuspense(<NotFoundPage />),
          handle: { crumb: "Not found" },
        },
      ],
    },
  ],
  { basename: import.meta.env.BASE_URL.replace(/\/$/, "") || "/" },
)

export function AppRouter() {
  return <RouterProvider router={router} />
}
